import { Alert, LinearProgress } from '@mui/material'
import Box from '@mui/material/Box'
import axios from 'api/axios'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import ThemeManager from 'theming/ThemeManager'
import CamposSolicitud from '../components/CamposSolicitud'
import DatosSolicitud from '../components/DatosSolicitud'

const Solicitud = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [params, setSearchParams] = useSearchParams()

  const [solicitud, setSolicitud] = useState()
  const [editando, setEditando] = useState(false)
  const [campos, setCampos] = useState([])
  const [camposLoading, setCamposLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const themeController = new ThemeManager()

  let CamposSolicitudComp = CamposSolicitud

  if (
    themeController?.activeTheme?.components &&
    themeController.activeTheme.components['CamposSolicitud']
  ) {
    CamposSolicitudComp = themeController.activeTheme?.components
      ? (themeController.activeTheme?.components['CamposSolicitud'] ?? CamposSolicitud)
      : CamposSolicitud
  }

  useEffect(() => {
    setLoading(true)

    if (location?.state?.solicitud) setSolicitud(location.state.solicitud)
    if (location?.state?.editando) setEditando(location.state.editando)

    const stored = sessionStorage.getItem('solicitudSeleccionada')
    const solicitudSesion = stored ? JSON.parse(stored) : null
    if (solicitudSesion) {
      setSolicitud(solicitudSesion)
    }

    let origen = params.get('origen')
    let codigo = params.get('codigo')

    if (solicitud && (!origen || !codigo)) {
      codigo = solicitud.codigo_solicitud
      origen = solicitud.origen_solicitud
    }

    if ((!origen || !codigo) && location?.state?.solicitud) {
      origen = location.state.solicitud.origen_solicitud
      codigo = location.state.solicitud.codigo_solicitud
    }

    if ((!origen || !codigo) && solicitudSesion) {
      origen = solicitudSesion.origen_solicitud
      codigo = solicitudSesion.codigo_solicitud
    }

    if (origen && codigo) {
      setCamposLoading(true)
      axios
        .get(`solicitud/datos/${codigo}/${origen}/`)
        .then((response) => {
          const data = response.data
          setSolicitud(data.solicitud)
          setCampos(data.campos)
        })
        .catch((error) => setError(error))
        .finally(() => {
          setLoading(false)
          setCamposLoading(false)
          sessionStorage.removeItem('solicitudSeleccionada')
          return
        })
    }

    if (!location?.state?.solicitud && (!origen || !codigo) && !solicitudSesion)
      navigate('/listasolicitudes/')
  }, [location]) // Es necesario tener location en el array de dependencias para que reaccione cuando se crea una nueva solicitud

  return (
    <Box>
      {solicitud?.codigo_solicitud && solicitud?.origen_solicitud && !editando ? (
        <DatosSolicitud solicitud={solicitud} campos={campos} camposLoading={camposLoading} />
      ) : solicitud?.tipo && solicitud?.subtipo ? (
        <CamposSolicitudComp solicitud={solicitud} editando={editando} />
      ) : (
        <Box>
          {loading ? (
            <LinearProgress />
          ) : error ? (
            <Alert severity="error">Ha ocurrido un error</Alert>
          ) : (
            <></>
          )}
        </Box>
      )}
    </Box>
  )
}

export default Solicitud
